import graphql from "babel-plugin-relay/macro";

export default graphql`
  query getAttendeesPropertiesBreakdownQuery($orgId: ID!, $propertyIds: [String!], $eventIds: [String!], $startAt: String!, $endAt: String!){
    attendeesPropertiesBreakdown(orgId:$orgId, propertyIds:$propertyIds, eventIds:$eventIds, startAt:$startAt, endAt:$endAt){
      maxNoOfGuests
      rsvpedCount
      waitlistedCount
      canceledCount
      notAttendedCount
      attendedCount
      propertyName
      id
      title
      propertyId
      startAt
      endAt
    }
  }
` 